import User from "app/models/user"
import { Action, Types } from "./users.actions"

export type Params = {
  q?: string
  sort?: string[]
  pageSize?: number
  page?: number
  functions?: []
}

export type UsersState = {
  data: User[]
  errors: object
  loading: boolean
  user: User | undefined
  params: Params
}

const initialState: UsersState = {
  data: [],
  errors: {},
  loading: false,
  user: undefined,
  params: { sort: ["full_name=asc"] },
}

export default (state = initialState, action: Action): UsersState => {
  switch (action.type) {
    case Types.GET:
      if (action.payload.params) {
        return {
          ...state,
          params: action.payload.params,
          loading: true,
        }
      }
      return state

    case Types.GET_SUCCESS:
      return {
        ...state,
        data: action.payload.data || [],
        loading: false,
      }

    case Types.GET_FAIL:
      return {
        ...state,
        errors: action.payload.errors,
        loading: false,
      }

    case Types.DELETE:
      return {
        ...state,
        loading: true,
      }

    case Types.DELETE_SUCCESS:
      return {
        ...state,
        loading: false,
      }

    case Types.DELETE_FAIL:
      return {
        ...state,
        errors: action.payload.errors,
        loading: false,
      }

    case Types.POST:
      return {
        ...state,
        loading: true,
      }

    case Types.POST_SUCCESS:
      return {
        ...state,
        loading: false,
      }

    case Types.POST_FAIL:
      return {
        ...state,
        errors: action.payload.errors,
        loading: false,
      }

    case Types.GET_BY_ID:
      return {
        ...state,
        loading: true,
      }

    case Types.GET_BY_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        user: action.payload.data,
      }

    case Types.GET_BY_ID_FAIL:
      return {
        ...state,
        errors: action.payload.errors,
        loading: false,
      }

    case Types.PATCH: {
      return {
        ...state,
        loading: false,
      }
    }

    case Types.PATCH_SUCCESS:
      return {
        ...state,
        loading: false,
        data: state.data.map((user: User) => {
          if (user.id === action.payload.data.id) return action.payload.data
          return user
        }),
        user: action.payload.data,
      }

    case Types.PATCH_FAIL:
      return {
        ...state,
        errors: action.payload.errors,
        loading: false,
      }

    default:
      return state
  }
}
